import axios from 'axios';

const apiBrasil = axios.create({
  baseURL: 'https://brasilapi.com.br/api',
});

export default apiBrasil;
